(()=>{
  if(window.nivoraHalloweenCleanup) window.nivoraHalloweenCleanup();
  const lifecycle=new AbortController();
  const {signal}=lifecycle;
  const one=(s,r=document)=>r.querySelector(s);
  const all=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const read=id=>{try{return JSON.parse(document.getElementById(id)?.textContent||'null')}catch{return null}};

  const opts=read('nivora-options')||{};
  const labels=opts.labels||{};
  const catalog=read('nivora-halloween-catalog')||[];
  const information=read('nivora-brand-information')||{};
  const root=window.Shopify?.routes?.root||opts.root||'/';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let motion=!reduced.matches;
  let cartBusy=false;

  const create=(tag,cls,text)=>{
    const el=document.createElement(tag);
    if(cls) el.className=cls;
    if(text!==undefined) el.textContent=text;
    return el;
  };

  function closeDialogs(){
    all('.shop-dialog[open]').forEach(dialog=>dialog.close());
  }

  function openDialog(id){
    closeDialogs();
    const dialog=document.getElementById(id);
    if(!dialog) return;
    dialog.showModal();
    if(id==='nivora-bag') loadCart();
    if(id==='nivora-search'){
      const input=one('[data-search-input]',dialog);
      renderSearch(input?.value||'');
      requestAnimationFrame(()=>input?.focus());
    }
  }

  function info(key){
    const value=information[key];
    if(!value) return;
    openDialog('nivora-info');
    const dialog=document.getElementById('nivora-info');
    const title=one('[data-info-title]',dialog);
    const body=one('[data-info-text]',dialog);
    if(title) title.textContent=value.title;
    if(body) body.replaceChildren(...value.text.map(text=>create('p','',text)));
  }

  function result(product){
    const link=create('a','product-result');
    link.href=product.url;
    const photo=create('span','result-photo');
    if(product.image){
      const img=document.createElement('img');
      img.src=product.image;
      img.alt='';
      img.width=180;
      img.height=190;
      img.loading='lazy';
      photo.append(img);
    }
    const body=create('span');
    body.append(
      create('strong','',product.name),
      create('small','',(product.priceVaries?'From ':'')+(product.priceText||''))
    );
    link.append(photo,body,create('span','','↗'));
    return link;
  }

  function renderSearch(query){
    const target=one('[data-search-results]');
    if(!target) return;
    const words=query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
    const matches=catalog.filter(product=>{
      if(!words.length) return true;
      const haystack=(product.name+' '+product.description+' halloween ghost pumpkin projector light decor').toLocaleLowerCase();
      return words.every(word=>haystack.includes(word));
    }).slice(0,6);
    target.replaceChildren(...matches.map(result));
    if(!matches.length) target.append(create('p','search-no-results',labels.noResults||'No products match that search.'));
  }

  async function loadCart(){
    const status=one('[data-cart-status]');
    try{
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},signal});
      if(!response.ok) throw new Error('cart');
      const cart=await response.json();
      all('[data-bag-count]').forEach(el=>el.textContent=cart.item_count);
      const total=one('[data-cart-total]');
      if(total) total.textContent=formatMoney(cart.total_price);
      const checkout=one('[data-cart-checkout]');
      if(checkout) checkout.disabled=!cart.item_count;
      const target=one('[data-cart-items]');
      if(!target) return;
      target.replaceChildren();

      if(!cart.items.length){
        const empty=create('div','cart-empty');
        empty.append(
          create('h3','',labels.empty||'Your bag is empty.'),
          create('p','',labels.emptyDescription||'Start with one small thing for after dark.')
        );
        target.append(empty);
      }

      for(const item of cart.items){
        const row=create('article','cart-item');
        if(item.image){
          const img=document.createElement('img');
          img.src=item.image;
          img.alt=item.product_title;
          img.width=168;
          img.height=192;
          img.loading='lazy';
          row.append(img);
        }
        const body=create('div','cart-item-info');
        const link=create('a','',item.product_title);
        link.href=item.url;
        body.append(link);
        if(item.variant_title) body.append(create('p','',item.variant_title));

        const controls=create('div','quantity-controls');
        const minus=create('button','','−');
        minus.type='button';
        minus.dataset.cartKey=item.key;
        minus.dataset.cartQuantity=Math.max(0,item.quantity-1);
        minus.setAttribute('aria-label',(labels.decrease||'Decrease quantity for')+' '+item.product_title);
        const qty=create('span','',String(item.quantity));
        const plus=create('button','','+');
        plus.type='button';
        plus.dataset.cartKey=item.key;
        plus.dataset.cartQuantity=item.quantity+1;
        plus.setAttribute('aria-label',(labels.increase||'Increase quantity for')+' '+item.product_title);
        controls.append(minus,qty,plus);
        body.append(controls,create('strong','',formatMoney(item.final_line_price)));

        const remove=create('button','text-button',labels.remove||'Remove');
        remove.type='button';
        remove.dataset.cartKey=item.key;
        remove.dataset.cartQuantity='0';
        remove.setAttribute('aria-label',(labels.remove||'Remove')+' '+item.product_title);
        body.append(remove);
        row.append(body);
        target.append(row);
      }
      if(status) status.textContent='';
    }catch(error){
      if(error.name!=='AbortError'&&status) status.textContent=labels.error||'Something went wrong. Please try again.';
    }
  }

  function formatMoney(cents){
    return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:opts.currency||'EUR'}).format(cents/100);
  }

  async function changeCart(button){
    if(cartBusy) return;
    cartBusy=true;
    all('[data-cart-key]').forEach(el=>el.disabled=true);
    try{
      const response=await fetch(root+'cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({id:button.dataset.cartKey,quantity:Number(button.dataset.cartQuantity)}),
        signal
      });
      if(!response.ok) throw new Error('cart');
      await loadCart();
    }catch(error){
      if(error.name!=='AbortError'){
        const status=one('[data-cart-status]');
        if(status) status.textContent=labels.error||'Something went wrong. Please try again.';
      }
    }finally{
      cartBusy=false;
      all('[data-cart-key]').forEach(el=>el.disabled=false);
    }
  }

  function setMotion(){
    document.documentElement.dataset.nivoraMotion=motion?'on':'off';
    all('[data-motion]').forEach(button=>{
      button.disabled=reduced.matches;
      button.setAttribute('aria-pressed',String(motion));
      button.textContent=reduced.matches?(labels.reduced||'Motion: reduced'):motion?(labels.pause||'Motion: on'):(labels.play||'Motion: off');
    });
  }

  function updateHeader(){
    one('[data-nivora-header]')?.classList.toggle('scrolled',window.scrollY>22);
  }

  function updateVariant(select){
    const option=select.selectedOptions[0];
    if(!option) return;
    const panel=select.closest('.product-info-panel');
    const price=one('[data-product-price]',panel);
    const compare=one('[data-product-compare]',panel);
    const add=one('[data-add-to-bag]',panel);
    if(price) price.textContent=option.dataset.price||'';
    if(compare){
      const value=option.dataset.compare||'';
      compare.textContent=value;
      compare.hidden=!value;
    }
    if(add){
      const available=option.dataset.available==='true';
      add.disabled=!available;
      add.innerHTML=available?'Add to bag <span aria-hidden="true">↗</span>':'Sold out';
    }
    const url=new URL(location.href);
    url.searchParams.set('variant',option.value);
    history.replaceState({},'',url);
  }

  document.addEventListener('click',event=>{
    const target=event.target.closest('button,a');
    if(!target) return;
    if(target.hasAttribute('data-close')){
      target.closest('dialog')?.close();
      return;
    }
    if(target.dataset.dialog){
      event.preventDefault();
      openDialog(target.dataset.dialog);
      return;
    }
    if(target.dataset.info){
      event.preventDefault();
      info(target.dataset.info);
      return;
    }
    if(target.hasAttribute('data-scroll-close')) closeDialogs();
    if(target.hasAttribute('data-motion')){
      motion=!motion&&!reduced.matches;
      setMotion();
      return;
    }
    if(target.dataset.cartKey) changeCart(target);
  },{signal});

  document.addEventListener('input',event=>{
    if(event.target.matches('[data-search-input]')) renderSearch(event.target.value);
  },{signal});

  document.addEventListener('change',event=>{
    if(event.target.matches('[data-variant-select]')) updateVariant(event.target);
  },{signal});

  document.addEventListener('click',event=>{
    if(event.target.matches('.shop-dialog[open]')){
      const rect=event.target.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) event.target.close();
    }
  },{signal});

  document.addEventListener('pointermove',event=>{
    if(!motion||event.pointerType!=='mouse') return;
    const hero=event.target.closest('[data-hero]');
    if(!hero) return;
    const media=one('[data-hero-media]',hero);
    if(!media) return;
    const rect=hero.getBoundingClientRect();
    const x=((event.clientX-rect.left)/rect.width-.5)*12;
    const y=((event.clientY-rect.top)/rect.height-.5)*8;
    media.style.setProperty('--look-x',x+'px');
    media.style.setProperty('--look-y',y+'px');
  },{passive:true,signal});

  const observer='IntersectionObserver' in window
    ? new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      }),{threshold:.09,rootMargin:'0px 0px -4% 0px'})
    : null;

  function init(){
    all('.reveal:not(.in-view)').forEach(el=>observer?observer.observe(el):el.classList.add('in-view'));
    all('[data-variant-select]').forEach(updateVariant);
    setMotion();
    updateHeader();
  }

  window.addEventListener('scroll',updateHeader,{passive:true,signal});
  document.addEventListener('shopify:section:load',init,{signal});
  reduced.addEventListener('change',()=>{motion=!reduced.matches;setMotion()},{signal});

  window.nivoraHalloweenCleanup=()=>{
    lifecycle.abort();
    observer?.disconnect();
  };

  init();
})();
